import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BackArrowIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z"
        fill={color}
      />
    </Svg>
  );
}

export default BackArrowIcon;
